export enum StockAvailabilityType {
	BUILD_TO_ORDER = 'buildToOrder',
	IN_STOCK = 'inStock',
	OUT_OF_STOCK = 'outOfStock',
	HIDE_STOCK_LABEL = 'hideStockLabel',
}
